import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { FinalUser } from 'src/app/models/final-user.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { globals } from '../utils/globals';
import { HttpService } from '../services/http-service';
import { UrlService } from '../services/url-service';
import { TransferStateService } from 'src/services/transfer-state.service';
import { TokenStorageService } from 'src/services/token-storage.service';

@Injectable()
export class AudioRestService extends HttpService<any> {
  private btnDisabled = new BehaviorSubject<boolean>(true);
  btnDisabled$ = this.btnDisabled.asObservable();

  constructor(
    override _translateService: TranslateService,
    override _globals: globals,
    override _http: HttpClient,
    override _transferStateService: TransferStateService,
    private _tokenStorageService: TokenStorageService,
    private urlService: UrlService,
  ) {
    super(_http, _translateService, _globals, _transferStateService);
  }

  setBtnDisabled(valor: boolean) {
    this.btnDisabled.next(valor);
  }

  getBtnDisabled$(): Observable<boolean> {
    return this.btnDisabled$;
  }

  uploadAudio(
    audio: Blob
  ): Observable<any> {
    let url = this.urlService.getFileUploadURL();
    let formData = new FormData();
    formData.append('file', audio);
    let header = {};
    /*
    let tokenObject = this._tokenStorageService.getToken();
    if (tokenObject) {
      header['Authorization'] = 'Bearer ' + tokenObject!.getAccessToken();
    }*/
    return this._postAttachment(url, formData).pipe(
      map((result: any) => {
        return result;
      }),
      catchError((error: any) => {
        console.error(error);
        // Manejar el error aquí
        return error;
      })
    );
  }

  deleteAudioById(id: string): Observable<any> {
    let url = this.urlService.getDeleteFinalUserAudioURL() + id;

    let header: any = {};
    let tokenObject = this._tokenStorageService.getToken();
    if (tokenObject) {
      header['Authorization'] = 'Bearer ' + tokenObject;
    }
    let headers = new HttpHeaders();
    if (tokenObject) {
    headers = headers.set('Authorization', 'Bearer ' + tokenObject);
    }
    return this._http.delete(url, {headers}).pipe(
        map((result: any) => {
          return result;
        })
    );
  }

  getAllAudiosByUserID(id : any): Observable<any>{
    let url = this.urlService.getAllFinalUserAudiosByUserIdURL() + id;

    let data: any = {};
    let header: any = {};
    let tokenObject = this._tokenStorageService.getToken();
    if (tokenObject) {
      header['Authorization'] = 'Bearer ' + tokenObject;
    }
    return this._get(url, data, header).pipe(
      map((result: any) => {
        return result;
      })
    )
  }
}
